import React, {useEffect, useState, useRef} from "react";
import "./style.scss";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
// import {dataDashboard} from "../../util";
import {getCustomerSlotDetails} from "../../services/SessionStorage";
import config from "../../../config";

const Menu = ({close}) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const closeButton = "X";
  const tempArray = useRef([
    {
      text: t("displayAppointment.title"),
      id: "/customer/displayAppointments",
      iconClass: "add-small-calender-icon",
    },
  ]);
  const [menuItems, setMenuItems] = useState([]);
  const handleSelect = (link, text) => {
    // const datamap = new Map();
    // if (text === t("displayAppointment.title")) {
    //   datamap.set("events", "event56=1");
    // } else {
    //   datamap.set("events", "event57=1");
    // }
    // dataDashboard(datamap);
    navigate(link);
  };

  useEffect(() => {
    let data = getCustomerSlotDetails();
    if (config.turnero_enabled_bu_list.includes(data.bu)) {
      tempArray.current.push({
        text: t("displayTurneros.title"),
        id: "/customer/displayTurnero",
        iconClass: "add-small-calender-icon",
      });
    }
    setMenuItems(tempArray.current);
  }, [t]);

  return (
    <div className="menu-fullscreen-container" onClick={close}>
      <div className="menu-contents-container">
        <div className="menu-screen-header">
          <h3 className="menu-header">{t("menu.title")}</h3>
          <div className="close-btn" onClick={close}>
            {" "}
            {closeButton}
          </div>
        </div>
        {menuItems.map((s) => (
          <div
            className="menu-item"
            key={s.id}
            onClick={() => {
              handleSelect(s.id, s.text);
            }}
          >
            <div className="each-menu-item">
              <div className={s.iconClass}></div>
              <label className="menu-text"> {s.text}</label>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Menu;
